import { render, staticRenderFns } from "./OverallReportPage.vue?vue&type=template&id=58c8a775"
import script from "./OverallReportPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./OverallReportPage.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports